import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { MapPin, Clock, Phone, Store } from 'lucide-react';
import './PickupSelector.css';

function PickupSelector({ selected, onSelectionChange, subtotal }) {
  const [pickupLocations, setPickupLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPickupLocations();
  }, []);

  const loadPickupLocations = async () => {
    try {
      const pickupSnapshot = await getDocs(collection(db, 'pickupLocations'));
      const locations = pickupSnapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(location => location.active)
        .sort((a, b) => a.name.localeCompare(b.name));
      
      setPickupLocations(locations);
      setLoading(false);
    } catch (error) {
      console.error('Error loading pickup locations:', error);
      setLoading(false);
    }
  };

  const handleLocationSelect = (location) => {
    onSelectionChange({
      type: 'pickup',
      location: location,
      cost: 0,
      estimatedReady: location.estimatedReady
    });
  };

  if (loading) {
    return (
      <div className="pickup-selector">
        <div className="pickup-loading">
          <div className="spinner"></div>
          <p>Loading pickup locations...</p>
        </div>
      </div>
    );
  }

  if (pickupLocations.length === 0) {
    return (
      <div className="pickup-selector">
        <div className="pickup-unavailable">
          <Store size={48} />
          <h3>Pickup Currently Unavailable</h3>
          <p>No pickup locations are currently configured</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pickup-selector">
      <div className="pickup-header">
        <h3><Store size={20} /> Local Pickup</h3>
        <p>Free pickup from our locations</p>
      </div>

      <div className="pickup-locations">
        {pickupLocations.map(location => (
          <div
            key={location.id}
            className={`pickup-location ${selected?.location?.id === location.id ? 'selected' : ''}`}
            onClick={() => handleLocationSelect(location)}
          >
            <div className="pickup-location-content">
              <div className="pickup-location-header">
                <span className="pickup-icon">{location.icon}</span>
                <div className="pickup-location-info">
                  <h4>{location.name}</h4>
                  <p><MapPin size={14} /> {location.address}</p>
                  <p><Phone size={14} /> {location.phone}</p>
                  <p><Clock size={14} /> {location.hours}</p>
                </div>
              </div>
              <div className="pickup-location-footer">
                <span className="ready-time">Ready in {location.estimatedReady}</span>
                <span className="pickup-price">FREE</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PickupSelector;
